/**
 * 访问资源国际化
 * date：2022 03 07
 */
export default {
  public: {
    // 客户状态
    customer_status_cancel: 'Disable',
    customer_status_active: 'Enable',
    // 用户状态
    user_status_cancel: 'Disable',
    user_status_activity: 'Enable',
    // 角色状态
    role_status_cancel: 'Cancel',
    role_status_activity: 'Enable',

    // 客户类型
    customer_type_platform: 'Company',
    customer_type_noplatform: 'Company',

    is_platform: 'Company',
    not_platform: 'Company',

    // 用户类型
    user_type_default: 'Default User',
    user_type_nodefault: 'Non-default User',

    // 账户类型
    account_type_default: 'Default Account',
    account_type_nodefault: 'Non-default Account',

    // 角色类型
    role_type_platform: 'Platform Role',
    role_type_noplatform: 'Non Platform Role',

    // 角色类型
    role_type_default: 'Default Role',
    role_type_nodefault: 'Non-default Role',

    customer_org_type_00: 'Disease Control',
    customer_org_type_01: 'Community Hospital',
    customer_org_type_02: 'General Hospital',
    customer_org_type_03: "Children's Hospital",
    customer_org_type_04: 'MHC Hospital',
    customer_org_type_05: 'PM Institutions',
    customer_org_type_09: 'Other',
    please: 'Please Select',

    // 角色类型
    role_customer_proxy: 'Agent Admin',
    role_customer_nomal: 'Company User',
    role_customer_admin: 'Company Admin',
    role_platform_normal: 'Platform User',
    role_platform_admin: 'Platform Admin',

    // 客户
    All: 'All',
    Proxy: 'Agent Role',
    details: 'Details',
    detail: 'Details',
    phone_num: 'Mobile',

    // 等级
    level_0: 'Level 0',
    level_1: 'Level 1',
    level_2: 'Level 2',
    level_3: 'Level 3',
    level_4: 'Level 4',

    // 模式
    mode_view: 'View Mode',
    mode_edit: 'Edit Mode',

    // 等级对应的角色
    level_0_role: 'All User',
    level_1_role: 'Non-regular User',
    level_2_role: 'Platform & Root User',
    level_3_role: 'System Admin，Root User',
    level_4_role: 'Root User',

    // 公用
    prompt: 'Tips',
    least_one_data: 'Please select at least one record.',
    no_data: 'No Data Available',
    no_more: 'No More',
    please_enter: 'Please Enter',
    fail: 'Failed',
    success: 'Send Successful',
    system_error: 'System Error',
    email: 'Email',
    emailbox: 'Email',
    sensor: 'Select Sensor',
    gateway: 'Gateway',
    display: 'Show Label',
    relay: 'Repeater',
    reuse: 'Reactivate',
    wechat: 'Wechat',
    blog: 'Microblog',
    edit: 'Edit',
    sample_value: 'Reading',
    net_param: 'Set Network Parameters',
    escalation_rules: 'Manage Report Rules',
    sound_light_alarm: 'Sound & Light Alarm',
    gps_param: 'GPS Parameters',
    // status: 'Operating Status',
    time: 'Time',
    Processed: 'Processed',
    type: 'Type',
    op_type: 'Type',
    op_time: 'Time',
    save: 'Save',
    saveImpl: 'Save and Execute',
    impl: 'Execute',
    choose: 'Select',
    config_status: 'Config Status',
    carrier: 'Asset',
    detail_info: 'Details',
    location_title: 'Current Location',
    group_title: 'Group Name',
    belong: 'Organization',
    belong_customer: 'Associated',
    belong_arch: 'Associated Organization',
    config: 'Config',
    config_info: 'Configuration Information',
    cancel: 'Cancel',
    command: 'Command',
    attribute: 'Attribute',
    history_data: 'Historical Records',
    carrier_detail: 'Asset Details',
    carrier_type: 'Asset Type',
    carrier_status: 'Asset Status',
    gateway_mac: 'Asset Gateway MAC',
    alarm_switch: 'Alarm Toggle',
    process_time: 'Handling Time',
    start_date: 'Start Date',
    end_date: 'End Date',
    start_time: 'Start Time',
    end_time: 'End Time',
    to: 'to',
    reason: 'Cause',
    handler: 'Handled By',
    handle: 'Handle',
    return_handle: 'Returned for Handling',
    handle_success: 'Handling Successful',
    data: 'Historical Records',
    amount: 'Amount',
    delete_fail: 'Deletion Failed',
    unknown_error: 'Unknown Error',
    delete_success: 'Deletion Successful',
    exception: 'Abnormal',

    // 表头
    table_scope: 'Company',
    table_customer_code: 'Company ID',
    table_contact: 'Contact',
    table_phone: 'Mobile/Phone',
    table_email: 'Email',
    table_scope_type: 'Company Type',
    table_operation: 'Actions',
    table_arch: 'Organization',
    table_name: 'Instance Name',
    table_carrier: 'Asset',
    table_code: 'ID/SN',
    table_desc: 'Description',
    table_create_time: 'Create Time',
    table_carrier_name: 'Asset Name',

    // 表格操作
    tbopt_delete: 'Delete',
    tbopt_detail: 'Details',
    tbopt_edit: 'Edit',

    // 按钮
    btn_confirm: 'Ok',
    btn_cancel: 'Cancel',
    btn_new: 'New',
    btn_delete: 'Delete',
    btn_close: 'Close',
    btn_apply: 'OK',
    btn_view: 'View Report',
    btn_delete_all: 'Delete All',
    btn_add: 'New',
    create_user: 'Create User',
    btn_yes: 'Yes',
    btn_no: 'No',
    yes: 'Yes',
    no: 'No',
    filter: 'Filter',
    btn_ok: 'OK',
    batchOperation: 'Batch Operation',
    batch_delete: 'Batch Delete',
    relogin_tip: 'Menu updated. The system navigation menu requires re-login to refresh. Re-login now?',
    sync_user: 'Sync Users',

    // 删除成功 失败等统一提示
    tip_del_succ: 'Deletion Successful',
    tip_del_fail: 'Deletion Failed',
    tip_add_succ: 'Successfully Added',
    tip_modify_succ: 'Update Successful',
    tip_save_succ: 'Save Successful',

    tip_confirm: 'Please confirm this operation.',
    tip_oper_succ: 'Operation Success',
    tip_oper_fail: 'Operation Failed',
    tip_upload_empty: 'Please select a file to upload.',
    tip_edit_succ: 'Edit Successful',
    // 监测点类型模块
    enabled: 'Enable',
    // stop: 'Stop',
    // 数据类型
    varchar: 'String',
    int: 'Number',
    double: 'Decimal',
    bigint: 'Time',

    icon_desc: 'The meaning of the icon is as follows,',
    carrier_run_status: 'Asset Status',
    is_abnormal: 'Abnormal or Not',
    temp: 'Temperature',
    hum: 'Relative Humidity',
    collect_data: 'Readings',
    sample: 'Sampling',
    reflash: 'Auto Refresh Time',
    search: 'Search',
    select_time: 'Select Date',
    speed: 'Speed',
    status: 'Status',
    location: 'Current Location',
    location_desc: 'Current Location',
    group_desc: 'Group Name',
    day: 'Days',
    hour: 'Hours',
    minute: 'Min',
    second: 'Seconds',
    total_num: 'Total',
    running: 'Running',
    online: 'Online',
    offline: 'Offline',
    stop: 'Disable',
    type_status_disable: 'Disable',
    open: 'Enable',
    close: 'Close',
    alarm_on: 'Alarm On',
    alarm_off: 'Alarm Off',
    bind: 'Bound',
    unbind: 'Unbound',
    device: 'Device',
    device_key_label: 'Device Key',
    unconfirm: 'Pending',
    normal: 'Normal',
    using: 'Enable',
    operation_record: 'Actions History',
    setting: 'Settings',
    img: 'Picture',
    ex_conn: 'Disconnected',
    ex_temp: 'Temperature Abnormal',
    ex_hum: 'Humidity Abnormal',
    ex_data: 'Out of Range',
    ex_power: 'Power Off',
    trigger: 'Trigger',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    update_time: 'Update Time',
    basic_info: 'Basic Info',
    event: 'Event',
    interval: 'Interval',
    task: 'Task',
    content: 'Email Content',
    check_item: 'Check',
    times: 'Times',
    previous_next: 'Previous Next',
    calibration: 'Calibration',
    calibration_import: 'Calibration Import',
    verification_task: 'Verification Task',
    verify_object: 'Verify Object',
    task_start_time: 'Task Start Time',
    task_end_time: 'Task End Time',
    record_start_time: 'Recording Start Time',
    verify_desc: 'Verify Description',
    verify_device: 'Verify Device',
    add_verify_device: 'New Verify Equipment',
    verify_conditions: 'Verify Conditions',
    sampling_frequency : 'Sampling Frequency',
    verify_time: 'Verify Duration',
    calc_result: 'Calculation Result',
    verify_record: 'Verify Record',
    verify_notice: 'Verify Notification',
    temperature_deviation: 'Temperature Offset',
    humidity_deviation: 'Humidity Offset',
    temperature_fluctuation: 'Temperature Fluctuation',
    humidity_fluctuation: 'Humidity Fluctuation',
    temperature_uniformity: 'Temperature Uniformity',
    humidity_uniformity: 'Humidity Uniformity',
    recording_after: 'Start recording after meeting the conditions.',
    recording_start: 'Record immediately at the beginning of the task',
    notice_complet: 'Task Completion Notification',
    notice_timeout: 'Condition Timeout Notification',
    notice_except: 'Task Recording Exception Notification',
    timeout_setting: 'Timeout Setting',
    data_delay: 'Data Anomaly Delay',
    offline_delay: 'Offline Abnormal Delay',
    verify_device_title: 'Verify Device ID',
    upload_interval: 'Upload Interval',
    task_detail: 'Task Details',
    task_start: 'Task Starting',
    data_record: 'Data recording not enabled.',
    data_compare: 'Data Comparison',
    start_record: 'Start Recording',
    terminate_task: 'Terminate Task',
    distance_task: 'Time Left to Task End',
    are_you_sure_you_want_to_stop_task_q: 'Please confirm whether to terminate the task.',
    calibration_expired: 'Calibration Expiry Prompt',
    task_time: 'Task Time',
    demonstrations: 'Display Mode',
    taskName: 'Task Name',
    to_be_start: 'Pending Start',
    doing: 'In Progress',
    file_from: 'File generated from',
    sun: 'days',
    dataDuration: 'Data Duration',
    effective_anomaly: 'Valid Abnormal',
    all_anomaly: 'All Abnormalities',
    is_store_data: 'Please confirm whether to save the data.',
    compare_device: 'Comparison Devices',
    compare_start: 'Compare',
    installation_point_num: 'Asset Count',
    data_rate: 'Timeliness Reporting/Compliance Rate',
    total_info: 'Overall Information',
    temp_cannot_add_hum: 'Selected device has temperature sensors, humidity range cannot be added.',
    causes: 'Causes',
    ex_offline: 'Offline Abnormal',
    device_not_meet: 'The verification device has not yet met the conditions.',
    carrier_data_detail: 'Asset Data Details',
    data_timely_rate: 'Data Reporting Timeliness Rate',
    data_standard_rate: 'Data Reporting Compliance Rate',
    data_year_on_year: 'Data YoY',
    create_time: 'Record Time',
    file_name: 'File Name',
    repeated_rule_conditions_tips: 'The conditions under each rule cannot be duplicated.',
    alarm_detail: 'Alarm Details',
    ex_max_temp_hum: 'Max. Abnormal Temp&RH',
    ex_min_temp_hum: 'Min. Abnormal Temp&RH',
    ex_duration_temp: 'Maximum duration of temperature abnormal',
    ex_duration_hum: 'Maximum duration of humidity abnormal',
    ex_duration_offline: 'Maximum offline duration',
    ex_duration_power: 'Maximum duration of power outage',

    copy_right: 'Copyright ©',
    v_mark: 'V-mark',
    reserve_all_rights: 'All rights reserved.',
    // Footer (new)
    footer_rights: '© 2026 V-Mark Enterprises Ltd. All Rights Reserved.',
    footer_address: 'Address: #400-601 West Broadway, Vancouver, B.C. V5Z 4C2, Canada',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Terms of Use',
    total: 'Total',
    mode: 'Mode',
    statistic_preview: 'Statistical Preview',
    records_passed: 'Passed Record Count',
    please_select_statistics: 'Please select statistics',
    use_custom_interval: 'Apply Custom Range',
    use_default_interval: 'Apply Default Range',
    passing_rate: 'Pass Rate',
    statistic_object: 'Asset',
    select_at_least_one_asset: 'Please select at least one asset',
    greater_than: 'greater than',
    less_than: 'less than',
    greater_than_equal: 'greater than or equal',
    less_than_equal: 'less than or equal',
    filter_invalid_info: 'Filter invalid information',
    upper_limit: 'Upper Limit',
    lower_limit: 'Upper Limit',
    fault_duration_less: 'Fault Tolerance Duration is less than',
    continuous_anomal_less: 'Continuous anomalies less than',
    abnormal_frequency_less: 'Abnormal Frequency less than',
    reconnection_duration_less:'Reconnection duration less than',
    Power_duration_less: 'Power outage duration less than',
    jump_to_history: 'Jump to History Data',
    no_monitoring_interval_set: 'No Range',
    click_view_detail_abnormal: 'View the event',
    contact_details: 'Contact Details',
    downloading: 'Downloading...',
    guide_item_name: 'Guide Item Name',
    guide_code: 'Guide Item ID',
    enter_guide_name: 'Please enter the guide item name.',
    group: 'Group Name',
    delete_group: 'Delete Group',
    add_group: 'New Group',
    edit_group: 'Edit Group',
    curr_group: 'Current Group',
    add_guidance_item: 'New Guidance Item',
    edit_guidance_item: 'Edit Guidance',
    delete_guidance_item: 'Delete Guidance',
    modify_guidance_item_status: 'Update Guidance Status',
    apply_equipment: 'Request Device',
    equipment_maintenance: 'Device Maintenance',
    no_monitoring_points: 'Unassociated Asset',
    trigger_on: 'Enable Trigger',
    trigger_off: 'Disable Trigger',
    unrelated_trigger :'No Associated Trigger',
    work_mode: 'Work Mode',
    please_select_work_mode: 'Please select the work mode.',
    gps_switch: 'GPS Switch',
    switch: 'On/Off',
    go_download_page_view: 'Please view the file in the download page.',
    Exporting: 'Exporting…',
    Export_successful: 'Export Successful',
    Is_it_covered: 'Overwrite file?',
    Already_exists: 'Already Exists',
    sure_want_to_export: 'Please confirm whether to export the file.',
    Latest_collected_data_sampling: 'Latest Readings Sampling',
    Latest_collected_data_sampling_desc: 'At least one associated device is required. The latest readings will be used as the sample data.',
    Maximum_value_data_sampling: 'Max. Value Sampling',
    Maximum_value_data_sampling_desc: 'At least two associated devices are required. The maximum reading among the readings from two or more associated devices will be used as the sample data.',
    Minimum_value_data_sampling: 'Min. Value Sampling',
    Minimum_value_data_sampling_desc: 'At least two associated devices are required. The minimum reading among the readings from two or more associated devices will be used as the sample data.',
    Avg_value_data_sampling: 'Average Value  Sampling',
    Avg_value_data_sampling_desc: 'At least two associated devices are required. The average of the readings from two or more associated devices will be used as the sample data.',
    Equilibrium_value_data_sampling: 'Balanced Value Sampling',
    Equilibrium_value_data_sampling_desc: 'At least three associated devices are required. Remove the maximum and minimum readings from the data collected by three or more associated devices, calculate the average of the remaining readings, and use it as the sample data.',
    Transport_Code: 'Transport Code',
    Filter_conditions: 'Filter Conditions',
    abnormal_step_desc_1: 'The latest five abnormal messages is visible here.',
    carrier_step_desc_1: 'Click here to handle anomalies of sensor point.',
    abnormal_more_step_desc_2: 'Click more to view the complete list of exceptions',
    abnormal_all_step_desc_3: 'View all abnormal records in the menu [exception -> ex]',
    carrier_history_step_desc_1: 'Click here to view the historical data of this sensor point.',
    carrier_history_step_desc_2: 'Historical data can also be viewed in the list by clicking on the menu Asset ->Any Asset Type',
    go_home: 'Back Home',
    click_open_close_alarm: 'Click to turn on/off the alarm.',
    alarm_color_title_1: 'Alarm icon colors indicate different meanings.',
    alarm_color_red: 'Red -- Alarm Disabled',
    alarm_color_green: 'Green -- Alarm Enabled',
    alarm_color_gray: 'Gray -- No Trigger Associated',
    select_monitoring_here: 'Select Asset here',
    Carrier_list_desc:'Alarm switch can be enabled/disabled  in the sensor point (Asset ->any asset type)',
    history_desc_2:'Historical data view is in the Data Dashboard ->Asset.',
    abnormal_tips: 'Abnormal Prompt',
    sensors_offline_red : 'If any sensor goes offline during the sampling period, this icon will turn red.',
    select_monitoring: 'Senor Point Selection',
    Open_report_statistics: 'Open Report Statistics',
    Open_report_statistics_detail: 'Open Report Statistics ->Data Details',
    set_export_conditions: 'Export Settings',
    set_export_go_download: 'Set export conditions and click Export, then download files from the download list.',
    download_desc_1: 'Exported files can be downloaded from the download menu.',
    open_carrier_list: 'Open the sensor point list.',
    view_transport_Code_desc: 'Click to show transport QR code. Scan with WeChat to record temperature data of the sensor during transit. Note: This icon is only available when the monitoring point is in transport mode.',
    skip: 'Skip',
    next: 'Next',
    previous: 'Previous',
    Click_export_desc: 'Click to export data.',
    download_desc_2: 'The exported file can be downloaded from the download page',
    download_data: 'Download Data',
    abnormal_info: 'Abnormal Information',
    abnormal_handle: 'Abnormal Handle',
    abnormal_more: 'More Abnormalities',
    no_tips: 'Don\'t show again.',
    tips_close_success: 'Guide disabled successfully. You can re-enable it in your profile.',
    transport_Code_desc_2: 'This icon is only displayed when the sensor point is in transport mode. The transport code can be scanned via WeChat to record transport tracks and temperature.',
    upload_img_tips1: 'Upload image must be in JPG or PNG format.',
    upload_img_tips2: 'Upload image size cannot exceed 20MB.',

    table_file_type: 'File Type',
    load: 'Load',
    start:'Start',
    revoke:'Undo',

    // i18n additions
    keep_at_least_one_item: 'Keep at least one item.',
    confirm_delete_item: 'Are you sure you want to delete this item?',

  },
  deviceEvent: {
    alarm: 'Alarm Trigger',
    carry: 'Asset Device',
    ex: 'Abnormal Event',
    point: 'Location',
    info: 'Asset Info',
    all: 'All'
  }
}
